/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Sale_Or_RentInputs */

const cs_enum_sale_or_rent = /** @type {(inputs: Enum_Sale_Or_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodej i pronájem`)
};

const en_enum_sale_or_rent = /** @type {(inputs: Enum_Sale_Or_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale or rent`)
};

/**
* | output |
* | --- |
* | "Sale or rent" |
*
* @param {Enum_Sale_Or_RentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sale_or_rent = /** @type {((inputs?: Enum_Sale_Or_RentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Sale_Or_RentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sale_or_rent(inputs)
	return cs_enum_sale_or_rent(inputs)
});